import styled from "styled-components";
import { NARROW_VIEW_LIMIT } from "../../constants/Env";

export default styled.div`
  @media screen and (max-width: ${NARROW_VIEW_LIMIT}px) {
    display: none;
  }
`;
